import axios from 'axios';
import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.teams.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', teams: resp.data.data });
      });
  },

  select: (dispatch, team) => {
    dispatch({ type: 'SELECT', team });
  },

  create: (dispatch, params, successCallback, errorCallback) => {
    axios
      .post(routes.api.teams.create, params)
      .then((response) => {
        dispatch({ type: 'CREATE', team: response.data.data });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  update: (dispatch, team, params, successCallback, errorCallback) => {
    axios
      .patch(routes.api.teams.update(team.id), params)
      .then((response) => {
        dispatch({ type: 'UPDATE', team: response.data.data });
        successCallback();
      })
      .catch((error) => {
        errorCallback(error.response.data);
      });
  },

  destroy: (dispatch, team) => {
    axios
      .delete(routes.api.teams.destroy(team.id))
      .then((_response) => {
        dispatch({ type: 'DESTROY', team });
      });
  },
};
